import { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { useLang } from '../i18n/LanguageContext';
import { useLab } from '../i18n/LabContext';

const getActionMeta = (t) => ({
  session_start:    { label: t('action_session_start'),    color: 'var(--green)',  icon: '▶' },
  session_end:      { label: t('action_session_end'),      color: 'var(--text2)', icon: '⏹' },
  session_force_end:{ label: t('action_session_force_end'),color: 'var(--orange)', icon: '⚠' },
  walkin_start:     { label: t('action_walkin_start'),     color: 'var(--cyan)',  icon: '🚶' },
  walkin_stop:      { label: t('action_walkin_stop'),      color: 'var(--orange)',icon: '⏹' },
  topup_test:       { label: t('action_topup_test'),       color: 'var(--yellow)',icon: '🧪' },
  topup_click:      { label: t('action_topup_click'),      color: 'var(--green)', icon: '💳' },
  topup_payme:      { label: t('action_topup_payme'),      color: 'var(--green)', icon: '💳' },
  shift_open:       { label: t('action_shift_open'),       color: 'var(--purple)',icon: '🔓' },
  shift_close:      { label: t('action_shift_close'),      color: 'var(--red)',   icon: '🔒' },
  expense_add:      { label: t('action_expense_add'),      color: 'var(--orange)',icon: '💸' },
});

const fmt  = n  => Number(n || 0).toLocaleString() + ' so\'m';
const fmtN = n  => Number(n || 0).toLocaleString();
const fmtTime = ts => ts ? new Date(ts).toLocaleTimeString('uz-UZ', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';
const fmtDate = ts => ts ? new Date(ts).toLocaleDateString('uz-UZ', { day: '2-digit', month: '2-digit', year: '2-digit' }) : '—';
const fmtDur  = h  => { const hh = Math.floor(h); const mm = Math.round((h - hh) * 60); return hh > 0 ? `${hh}s ${mm}d` : `${mm} daqiqa`; };

const Card = ({ icon, value, label, color }) => (
  <div style={{
    background: 'var(--card2)', border: '1px solid var(--border)',
    borderRadius: 14, padding: '20px 24px', position: 'relative', overflow: 'hidden',
  }}>
    <div style={{ position: 'absolute', top: -15, right: -15, width: 80, height: 80,
      borderRadius: '50%', background: color, filter: 'blur(30px)', opacity: 0.35 }} />
    <div style={{ fontSize: 26, marginBottom: 10 }}>{icon}</div>
    <div style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 22, fontWeight: 700, color, marginBottom: 4 }}>{value}</div>
    <div style={{ fontSize: 12, color: 'var(--text2)' }}>{label}</div>
  </div>
);

// ── X/Z HISOBOT MODAL ─────────────────────────────────────────────────────
function ReportModal({ data, type, onClose }) {
  const { t } = useLang();
  if (!data) return null;
  const shortage = Number(data.cash_shortage || 0);
  const isShortage = shortage > 0;

  const printReport = () => {
    const w = window.open('', '_blank');
    w.document.write(`<html><head><title>${type === 'x' ? 'X' : 'Z'}-${t('print')}</title>
      <style>body{font-family:monospace;padding:20px;font-size:13px}h2{margin-bottom:8px}
      .row{display:flex;justify-content:space-between;padding:3px 0;border-bottom:1px dashed #ccc}
      .total{font-weight:bold;font-size:15px;margin-top:8px}.red{color:red}.green{color:green}</style>
      </head><body>
      <h2>${type === 'x' ? t('xReportInterim') : t('zReportFinal')}</h2>
      <p>Operator: <b>${data.operator_name}</b> | Ochildi: ${fmtDate(data.opened_at)} ${fmtTime(data.opened_at)}</p>
      ${data.closed_at ? `<p>Yopildi: ${fmtDate(data.closed_at)} ${fmtTime(data.closed_at)}</p>` : ''}
      <hr/>
      <div class="row"><span>Sessiyalar (naqd):</span><span>${fmtN(data.session_cash)} so'm</span></div>
      <div class="row"><span>Sessiyalar (karta):</span><span>${fmtN(data.session_card)} so'm</span></div>
      <div class="row"><span>Sessiyalar (balans):</span><span>${fmtN(data.session_balance)} so'm</span></div>
      <div class="row"><span>Snack-bar (naqd):</span><span>${fmtN(data.snack_cash)} so'm</span></div>
      <div class="row"><span>Snack-bar (jami):</span><span>${fmtN(data.snack_revenue)} so'm</span></div>
      ${Number(data.topup_total || data.topup_cash) > 0 ? `
      <div class="row"><span>Balans to'ldirish (naqd):</span><span>${fmtN(data.topup_cash)} so'm</span></div>
      <div class="row"><span>Balans to'ldirish (click):</span><span>${fmtN(data.topup_click)} so'm</span></div>
      <div class="row"><span>Balans to'ldirish (payme):</span><span>${fmtN(data.topup_payme)} so'm</span></div>
      <div class="row"><span>Balans to'ldirish (terminal):</span><span>${fmtN(data.topup_terminal)} so'm</span></div>` : ''}
      <div class="row total"><span>JAMI DAROMAD:</span><span class="green">${fmtN(data.total_revenue)} so'm</span></div>
      <hr/>
      <div class="row"><span>Boshlanish naqd:</span><span>${fmtN(data.opening_cash)} so'm</span></div>
      <div class="row"><span>Kutilgan naqd:</span><span>${fmtN(data.expected_cash)} so'm</span></div>
      ${data.closing_cash !== undefined ? `<div class="row"><span>Haqiqiy naqd:</span><span>${fmtN(data.closing_cash)} so'm</span></div>` : ''}
      ${shortage !== 0 ? `<div class="row total"><span>${isShortage ? 'KAMOMAD' : 'ORTIQCHA'}:</span><span class="${isShortage ? 'red' : 'green'}">${Math.abs(shortage).toLocaleString()} so'm</span></div>` : ''}
      <p>Sessiyalar: ${data.session_count || 0} ta | Yaratildi: ${new Date().toLocaleString()}</p>
      </body></html>`);
    w.document.close();
    w.print();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 18,
        padding: 32, width: 480, maxHeight: '90vh', overflowY: 'auto' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>{type === 'x' ? t('xReport') : t('zReport')}</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={printReport} style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid var(--cyan)',
              color: 'var(--cyan)', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
              🖨️ {t('printReport')}
            </button>
            <button onClick={onClose} style={{ background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text2)', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
              ✕ {t('close')}
            </button>
          </div>
        </div>

        <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 16 }}>
          {t('operator')}: <b style={{ color: 'var(--text)' }}>{data.operator_name}</b> ·
          {t('opened')}: {fmtDate(data.opened_at)} {fmtTime(data.opened_at)}
          {data.closed_at && ` · ${t('closed')}: ${fmtTime(data.closed_at)}`}
        </div>

        {/* Asosiy raqamlar */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
          {[
            { icon: '🖥️', label: t('sessionsLabel'), val: data.session_count || 0, isCount: true, color: 'var(--cyan)' },
            { icon: '👤', label: t('newClientsLabel'), val: data.new_clients_count || 0, isCount: true, color: 'var(--orange)' },
            { icon: '💰', label: t('totalRevenue'), val: fmt(data.total_revenue), color: 'var(--green)' },
            { icon: '💵', label: t('cashInRegisterModal'), val: fmt(data.closed_at ? data.closing_cash : data.expected_cash), color: 'var(--yellow)' },
          ].map(({ icon, label, val, isCount, color }) => (
            <div key={label} style={{ background: 'var(--card)', borderRadius: 10, padding: '12px 14px' }}>
              <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 4 }}>{icon} {label}</div>
              <div style={{ fontFamily: 'Orbitron, sans-serif', fontSize: isCount ? 22 : 14, fontWeight: 700, color }}>{val}</div>
            </div>
          ))}
        </div>

        {/* Daromad breakdown */}
        <div style={{ background: 'var(--card)', borderRadius: 12, padding: 16, marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 10, letterSpacing: 1, textTransform: 'uppercase' }}>{t('payMethodPC')}</div>
          {[
            { label: '💵 Naqd',    val: data.session_cash,     color: 'var(--green)' },
            { label: '🔵 Click',   val: data.session_click,    color: 'var(--blue)' },
            { label: '💳 Terminal',val: data.session_terminal, color: 'var(--cyan)' },
            { label: '📱 Payme',   val: data.session_payme,    color: 'var(--purple)' },
            { label: '🏦 Balans',  val: data.session_balance,  color: 'var(--text2)' },
          ].filter(x => Number(x.val) > 0).map(({ label, val, color }) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0',
              borderBottom: '1px solid var(--border)', fontSize: 13 }}>
              <span style={{ color: 'var(--text2)' }}>{label}</span>
              <span style={{ color, fontWeight: 600 }}>{fmtN(val)} so'm</span>
            </div>
          ))}
          {Number(data.snack_revenue) > 0 && (
            <>
              <div style={{ fontSize: 11, color: 'var(--text2)', margin: '8px 0 6px', letterSpacing: 1, textTransform: 'uppercase' }}>Snack-bar</div>
              {[
                { label: '💵 Naqd',    val: data.snack_cash,     color: 'var(--yellow)' },
                { label: '🔵 Click',   val: data.snack_click,    color: 'var(--blue)' },
                { label: '💳 Terminal',val: data.snack_terminal, color: 'var(--cyan)' },
              ].filter(x => Number(x.val) > 0).map(({ label, val, color }) => (
                <div key={`snack-${label}`} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0',
                  borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text2)' }}>{label}</span>
                  <span style={{ color, fontWeight: 600 }}>{fmtN(val)} so'm</span>
                </div>
              ))}
            </>
          )}
          {Number(data.topup_total || data.topup_cash) > 0 && (
            <>
              <div style={{ fontSize: 11, color: 'var(--text2)', margin: '8px 0 6px', letterSpacing: 1, textTransform: 'uppercase' }}>Balans to'ldirish ({data.topup_count || 0} ta)</div>
              {[
                { label: '💵 Naqd',    val: data.topup_cash,     color: 'var(--green)' },
                { label: '🔵 Click',   val: data.topup_click,    color: 'var(--blue)' },
                { label: '💳 Terminal',val: data.topup_terminal, color: 'var(--cyan)' },
                { label: '📱 Payme',   val: data.topup_payme,    color: 'var(--purple)' },
              ].filter(x => Number(x.val) > 0).map(({ label, val, color }) => (
                <div key={`topup-${label}`} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0',
                  borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text2)' }}>{label}</span>
                  <span style={{ color, fontWeight: 600 }}>{fmtN(val)} so'm</span>
                </div>
              ))}
            </>
          )}
          {Number(data.refund_total) > 0 ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: 13 }}>
                <span style={{ color: 'var(--text2)' }}>Brutto daromad</span>
                <span style={{ color: 'var(--text2)' }}>{fmt(data.total_revenue)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: 13 }}>
                <span style={{ color: 'var(--red)' }}>↩ Vazvrat ({data.refund_count || 0} ta)</span>
                <span style={{ color: 'var(--red)', fontWeight: 600 }}>−{fmtN(data.refund_total)} so'm</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 16, fontWeight: 800, borderTop: '2px solid var(--border)', marginTop: 4 }}>
                <span>SOF DAROMAD</span>
                <span style={{ color: 'var(--green)' }}>{fmt(data.net_revenue)}</span>
              </div>
            </>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 15, fontWeight: 700 }}>
              <span>{t('total').toUpperCase()}</span>
              <span style={{ color: 'var(--green)' }}>{fmt(data.total_revenue)}</span>
            </div>
          )}
        </div>

        {/* Naqd hisobi */}
        <div style={{ background: 'var(--card)', borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 10, letterSpacing: 1, textTransform: 'uppercase' }}>{t('cashRegister')}</div>
          {[
            { label: t('openingCash'), val: data.opening_cash },
            { label: t('expectedCash'), val: data.expected_cash },
            ...(data.closing_cash !== undefined ? [{ label: t('actualCash'), val: data.closing_cash }] : []),
          ].map(({ label, val }) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0',
              borderBottom: '1px solid var(--border)', fontSize: 13 }}>
              <span style={{ color: 'var(--text2)' }}>{label}</span>
              <span style={{ fontWeight: 600 }}>{fmtN(val)} so'm</span>
            </div>
          ))}
          {shortage !== 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 14, fontWeight: 700 }}>
              <span style={{ color: isShortage ? 'var(--red)' : 'var(--green)' }}>
                {isShortage ? `⚠️ ${t('shortage').toUpperCase()}` : `✅ ${t('surplus').toUpperCase()}`}
              </span>
              <span style={{ color: isShortage ? 'var(--red)' : 'var(--green)' }}>
                {Math.abs(shortage).toLocaleString()} so'm
              </span>
            </div>
          )}
        </div>

        <div style={{ fontSize: 12, color: 'var(--text3)' }}>
          {t('sessionsLabel')}: {data.session_count || 0} · {new Date().toLocaleTimeString()}
        </div>
      </div>
    </div>
  );
}

// ── SMENA YOPISH MODAL ────────────────────────────────────────────────────
function CloseShiftModal({ shift, onClose, onConfirm }) {
  const { t } = useLang();
  // Avtomatik hisoblangan summalar — backend /kassa/shift/current ichida
  // sessiyalar + snack + topup + refund'lardan tortib hisoblab beradi.
  // Admin inputda ko'rib, agar nimadir noto'g'ri bo'lsa to'g'rilashi mumkin.
  // expected_cash — opening_cash + barcha kirimlar - refund (naqd kassada
  // bo'lishi kerak bo'lgan summa). Boshqa to'lov turlari — session_*/snack_*/
  // topup_* ustunlarining yig'indisi.
  const _n = v => Number(v || 0);
  const autoCash     = Math.max(0, _n(shift?.expected_cash));
  const autoClick    = _n(shift?.session_click)    + _n(shift?.snack_click)    + _n(shift?.topup_click);
  const autoPayme    = _n(shift?.session_payme)    + _n(shift?.snack_payme)    + _n(shift?.topup_payme);
  const autoTerminal = _n(shift?.session_terminal) + _n(shift?.snack_terminal) + _n(shift?.topup_terminal);

  const [closingCash, setClosingCash]         = useState(autoCash ? String(Math.round(autoCash)) : '');
  const [closingClick, setClosingClick]       = useState(autoClick ? String(Math.round(autoClick)) : '');
  const [closingPayme, setClosingPayme]       = useState(autoPayme ? String(Math.round(autoPayme)) : '');
  const [closingTerminal, setClosingTerminal] = useState(autoTerminal ? String(Math.round(autoTerminal)) : '');
  const [closingCard, setClosingCard]         = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [pin, setPin]           = useState('');
  const [pinError, setPinError] = useState('');

  const requiresPin = !!shift?.staff_id;

  const total = (parseFloat(closingCash) || 0) + (parseFloat(closingClick) || 0) +
    (parseFloat(closingPayme) || 0) + (parseFloat(closingTerminal) || 0) + (parseFloat(closingCard) || 0);

  const handleClose = async () => {
    if (requiresPin && !pin.trim()) { setPinError(t('pinRequired') || 'PIN kod kiriting'); return; }
    setLoading(true);
    setPinError('');
    try {
      const res = await api.post('/kassa/shift/close', {
        closing_cash:     parseFloat(closingCash)     || 0,
        closing_click:    parseFloat(closingClick)    || 0,
        closing_payme:    parseFloat(closingPayme)    || 0,
        closing_terminal: parseFloat(closingTerminal) || 0,
        closing_card:     parseFloat(closingCard)     || 0,
        notes: note,
        pin: requiresPin ? pin.trim() : undefined,
      });
      onConfirm(res.data);
    } catch (e) {
      const msg = e.response?.data?.error || 'Xatolik';
      if (requiresPin && /PIN/i.test(msg)) setPinError(msg);
      else alert(msg);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', background: 'var(--card)', border: '1px solid var(--border)',
    color: 'var(--text)', padding: '9px 12px', borderRadius: 10, fontSize: 15,
    outline: 'none', boxSizing: 'border-box',
  };
  const labelStyle = { display: 'block', fontSize: 11, color: 'var(--text3)', marginBottom: 4 };

  const fields = [
    { label: '💵 Naqt pul',       value: closingCash,     set: setClosingCash },
    { label: '📱 Click',          value: closingClick,    set: setClosingClick },
    { label: '💳 Payme',          value: closingPayme,    set: setClosingPayme },
    { label: '🖨️ Terminal',       value: closingTerminal, set: setClosingTerminal },
    { label: '💳 Plastik karta',  value: closingCard,     set: setClosingCard },
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 18,
        padding: 28, width: 420, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 18px', fontSize: 18 }}>🔒 {t('closeShift')}</h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14 }}>
          {fields.map(f => (
            <div key={f.label}>
              <label style={labelStyle}>{f.label}</label>
              <input
                type="number"
                value={f.value}
                onChange={e => f.set(e.target.value)}
                placeholder="0"
                style={inputStyle}
              />
            </div>
          ))}
        </div>

        <div style={{
          background: 'rgba(0,212,255,0.06)', border: '1px solid rgba(0,212,255,0.2)',
          borderRadius: 10, padding: '10px 14px', marginBottom: 14,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <span style={{ fontSize: 12, color: 'var(--text3)' }}>Jami yopilish summasi</span>
          <span style={{ fontSize: 17, fontWeight: 700, color: 'var(--cyan)' }}>
            {total.toLocaleString()} so'm
          </span>
        </div>

        {requiresPin && (
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>🔐 {t('pinLabel') || 'PIN kod'} ({shift.operator_name})</label>
            <input
              type="password"
              inputMode="numeric"
              autoComplete="off"
              value={pin}
              onChange={e => { setPin(e.target.value); setPinError(''); }}
              placeholder="••••"
              maxLength={12}
              style={{ ...inputStyle,
                border: `1.5px solid ${pinError ? '#ef4444' : 'var(--border)'}`,
                fontSize: 18, textAlign: 'center', letterSpacing: 6 }} />
            {pinError && <div style={{ color: '#ef4444', fontSize: 12, marginTop: 6 }}>{pinError}</div>}
          </div>
        )}

        <div style={{ marginBottom: 18 }}>
          <label style={labelStyle}>{t('noteLabel')}</label>
          <input
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder={t('optionalPlaceholder')}
            style={{ ...inputStyle, fontSize: 13 }}
          />
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, background: 'transparent', border: '1px solid var(--border)',
            color: 'var(--text2)', padding: '11px', borderRadius: 10, cursor: 'pointer', fontSize: 13 }}>
            {t('cancel')}
          </button>
          <button onClick={handleClose} disabled={loading} style={{ flex: 2,
            background: 'rgba(255,59,92,0.15)', border: '1px solid var(--red)',
            color: 'var(--red)', padding: '11px', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
            {loading ? t('loading') : t('closeShiftBtn')}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── SMENA OCHISH MODAL ────────────────────────────────────────────────────
function OpenShiftModal({ onClose, onConfirm }) {
  const { t } = useLang();
  const [openingCash, setOpeningCash] = useState('');
  const [note, setNote]               = useState('');
  const [selectedKey, setSelectedKey] = useState('');  // "owner" | "staff_<id>"
  const [staffList, setStaffList]     = useState([]);
  const [loading, setLoading]         = useState(false);
  const [pin, setPin]                 = useState('');
  const [pinError, setPinError]       = useState('');

  useEffect(() => {
    const ownerData = JSON.parse(localStorage.getItem('owner') || '{}');
    const ownerEntry = ownerData.name ? [{ key: 'owner', id: null, name: ownerData.name }] : [];
    api.get('/staff').then(r => {
      const entries = (r.data || []).map(s => ({ key: `staff_${s.id}`, id: s.id, name: s.name, role: s.role }));
      setStaffList([...ownerEntry, ...entries]);
      if (ownerEntry.length) setSelectedKey(ownerEntry[0].key);
      else if (entries.length) setSelectedKey(entries[0].key);
    }).catch(() => {
      setStaffList(ownerEntry);
      if (ownerEntry.length) setSelectedKey(ownerEntry[0].key);
    });
  }, []);

  const selectedEntry = staffList.find(s => s.key === selectedKey);
  const isStaff = !!selectedEntry?.id;

  const handleOpen = async () => {
    if (!selectedEntry) { alert('Operator tanlang'); return; }
    if (isStaff && !pin.trim()) { setPinError(t('pinRequired') || 'PIN kod kiriting'); return; }
    setLoading(true);
    setPinError('');
    try {
      const res = await api.post('/kassa/shift/open', {
        opening_cash: parseFloat(openingCash) || 0,
        operator_name: selectedEntry.name,
        staff_id: selectedEntry.id || null,
        notes: note,
        pin: isStaff ? pin.trim() : undefined,
      });
      onConfirm(res.data);
    } catch (e) {
      const msg = e.response?.data?.error || 'Xatolik';
      if (isStaff && /PIN/i.test(msg)) setPinError(msg);
      else alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 18,
        padding: 32, width: 400 }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 20px', fontSize: 18 }}>🔓 {t('openShift')}</h2>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, color: 'var(--text2)', marginBottom: 6 }}>{t('whoOpening')}</label>
          {staffList.length > 0 ? (
            <select value={selectedKey} onChange={e => setSelectedKey(e.target.value)}
              style={{ width: '100%', background: 'var(--card)', border: '1px solid var(--border)',
                color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }}>
              <option value="">{t('selectPlaceholder')}</option>
              {staffList.map(s => <option key={s.key} value={s.key}>{s.name}{s.role ? ` · ${s.role}` : ''}</option>)}
            </select>
          ) : (
            <input value={selectedEntry?.name || ''} onChange={() => {}} placeholder="Ism kiriting..."
              style={{ width: '100%', background: 'var(--card)', border: '1px solid var(--border)',
                color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14,
                outline: 'none', boxSizing: 'border-box' }} />
          )}
        </div>

        {isStaff && (
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, color: 'var(--text2)', marginBottom: 6 }}>
              🔐 {t('pinLabel') || 'PIN kod'}
            </label>
            <input
              type="password"
              inputMode="numeric"
              autoComplete="off"
              value={pin}
              onChange={e => { setPin(e.target.value); setPinError(''); }}
              placeholder="••••"
              maxLength={12}
              style={{ width: '100%', background: 'var(--card)',
                border: `1.5px solid ${pinError ? '#ef4444' : 'var(--border)'}`,
                color: 'var(--text)', padding: '10px 14px', borderRadius: 10,
                fontSize: 18, textAlign: 'center', letterSpacing: 6,
                outline: 'none', boxSizing: 'border-box' }} />
            {pinError && <div style={{ color: '#ef4444', fontSize: 12, marginTop: 6 }}>{pinError}</div>}
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, color: 'var(--text2)', marginBottom: 6 }}>
            {t('openingCashLabel')}
          </label>
          <input type="number" value={openingCash} onChange={e => setOpeningCash(e.target.value)}
            placeholder="0"
            style={{ width: '100%', background: 'var(--card)', border: '1px solid var(--border)',
              color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 16,
              outline: 'none', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 12, color: 'var(--text2)', marginBottom: 6 }}>{t('noteLabel')}</label>
          <input value={note} onChange={e => setNote(e.target.value)} placeholder={t('optionalPlaceholder')}
            style={{ width: '100%', background: 'var(--card)', border: '1px solid var(--border)',
              color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 13,
              outline: 'none', boxSizing: 'border-box' }} />
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, background: 'transparent', border: '1px solid var(--border)',
            color: 'var(--text2)', padding: '11px', borderRadius: 10, cursor: 'pointer', fontSize: 13 }}>
            {t('cancel')}
          </button>
          <button onClick={handleOpen} disabled={loading || !selectedEntry} style={{ flex: 2,
            background: selectedEntry ? 'rgba(0,255,136,0.1)' : 'rgba(0,255,136,0.05)',
            border: '1px solid var(--green)', color: 'var(--green)', padding: '11px',
            borderRadius: 10, cursor: selectedEntry ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 700 }}>
            {loading ? t('loading') : t('openShiftBtn')}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── ASOSIY KOMPONENT ──────────────────────────────────────────────────────
export default function Kassa() {
  const { t } = useLang();
  const { mode: labMode } = useLab();
  // "Hammasi" rejim — yozish amallari (smena ochish/yopish) backend tomondan
  // 400 ("Avval klubni tanlang") qaytaradi. UI'da tugmani ko'rsatish o'rniga
  // tushuntiruv yozuvi beramiz (2.2 bosqich).
  const isAllMode = labMode === 'all';
  const [daily, setDaily]         = useState(null);
  const [shift, setShift]         = useState(null);
  const [shifts, setShifts]       = useState([]);
  const [audit, setAudit]         = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showOpenModal, setShowOpenModal]   = useState(false);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [reportType, setReportType] = useState('x');

  const load = useCallback(async () => {
    try {
      const [d, sh, shs, a] = await Promise.all([
        api.get('/kassa/daily').then(r => r.data),
        api.get('/kassa/shift/current').then(r => r.data),
        api.get('/kassa/shifts').then(r => r.data),
        api.get('/kassa/audit?limit=80').then(r => r.data),
      ]);
      setDaily(d); setShift(sh); setShifts(shs); setAudit(a);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000); // har 10 soniyada bugungi daromad va smena avto-yangilanadi
    const onFocus = () => load();       // sahifa aktivlashsa darhol yangilash
    window.addEventListener('focus', onFocus);
    return () => { clearInterval(t); window.removeEventListener('focus', onFocus); };
  }, [load]);

  async function showXReport() {
    try {
      const res = await api.get('/kassa/shift/xreport');
      setReportData(res.data);
      setReportType('x');
    } catch (e) { alert(e.response?.data?.error || 'Xatolik'); }
  }

  function shiftDuration(s) {
    if (!s) return '—';
    const ms = Date.now() - new Date(s.opened_at).getTime();
    return `${Math.floor(ms / 3600000)}s ${Math.floor((ms % 3600000) / 60000)}d`;
  }

  const actionMeta = getActionMeta(t);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
      <div style={{ fontFamily: 'Orbitron, sans-serif', color: 'var(--cyan)', fontSize: 18 }}>{t('loading')}</div>
    </div>
  );

  return (
    <div>
      {/* Modals */}
      {showOpenModal && (
        <OpenShiftModal
          onClose={() => setShowOpenModal(false)}
          onConfirm={() => { setShowOpenModal(false); load(); }}
        />
      )}
      {showCloseModal && (
        <CloseShiftModal
          shift={shift}
          onClose={() => setShowCloseModal(false)}
          onConfirm={data => { setShowCloseModal(false); setReportData(data); setReportType('z'); load(); }}
        />
      )}
      {reportData && (
        <ReportModal data={reportData} type={reportType} onClose={() => setReportData(null)} />
      )}

      {/* SARLAVHA */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>{t('kassaTitle')}</h1>
        <div style={{ color: 'var(--text2)', fontSize: 13 }}>
          {new Date().toLocaleDateString('uz-UZ', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
      </div>

      {/* SMENA PANELI */}
      <div style={{
        background: isAllMode ? 'rgba(0,212,255,0.05)' : shift ? 'rgba(0,255,136,0.05)' : 'rgba(255,59,92,0.05)',
        border: `1px solid ${isAllMode ? 'var(--cyan)' : shift ? 'var(--green)' : 'rgba(255,59,92,0.4)'}`,
        borderRadius: 16, padding: '20px 24px', marginBottom: 24,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ fontSize: 32 }}>{isAllMode ? '🌐' : shift ? '🟢' : '🔴'}</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: isAllMode ? 'var(--cyan)' : shift ? 'var(--green)' : 'var(--red)' }}>
              {isAllMode
                ? (t('selectLabForShift') || 'Smenani boshqarish uchun klubni tanlang')
                : shift ? `${t('shiftOpen')} — ${shiftDuration(shift)}` : t('shiftClosed')}
            </div>
            {!isAllMode && shift && (
              <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 3 }}>
                {shift.operator_name} · {fmtTime(shift.opened_at)} · {t('openingCash')}: {fmt(shift.opening_cash)}
              </div>
            )}
          </div>
        </div>

        {/* "Hammasi" rejimida smena tugmalari ko'rsatilmaydi — faqat tushuntiruv */}
        {!isAllMode && (shift ? (
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={showXReport} style={{
              background: 'rgba(0,212,255,0.1)', border: '1px solid var(--cyan)',
              color: 'var(--cyan)', padding: '10px 20px', borderRadius: 10,
              cursor: 'pointer', fontSize: 13, fontWeight: 600,
            }}>{t('xReport')}</button>
            <button onClick={() => setShowCloseModal(true)} style={{
              background: 'rgba(255,59,92,0.1)', border: '1px solid var(--red)',
              color: 'var(--red)', padding: '10px 20px', borderRadius: 10,
              cursor: 'pointer', fontSize: 13, fontWeight: 700,
            }}>🔒 {t('closeShift')}</button>
          </div>
        ) : (
          <button onClick={() => setShowOpenModal(true)} style={{
            background: 'rgba(0,255,136,0.1)', border: '1px solid var(--green)',
            color: 'var(--green)', padding: '10px 24px', borderRadius: 10,
            cursor: 'pointer', fontSize: 13, fontWeight: 700,
          }}>🔓 {t('openShift')}</button>
        ))}
      </div>

      {/* KPI KARTALAR */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 32 }}>
        <Card icon="💰" value={fmt(daily?.total_revenue)} label={t('todayRevenue')} color="var(--green)" />
        <Card icon="🖥️" value={daily?.session_count || 0} label={t('totalSessions')} color="var(--cyan)" />
        <Card icon="🚶" value={daily?.walkin_count || 0} label={t('walkinSessions')} color="var(--purple)" />
        <Card icon="📊" value={fmt(daily?.avg_value)} label={t('avgSession')} color="var(--orange)" />
      </div>

      {/* PASTKI QISM */}
      <div style={{ display: 'grid', gridTemplateColumns: '420px 1fr', gap: 20, alignItems: 'start' }}>

        {/* SMENA TARIXI */}
        <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--border)', fontSize: 11,
            color: 'var(--text2)', letterSpacing: 2, textTransform: 'uppercase' }}>{t('shiftHistory')}</div>
          {shifts.length === 0 ? (
            <div style={{ padding: '32px 20px', textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>{t('noShifts')}</div>
          ) : shifts.map(s => {
            const shortage = Number(s.cash_shortage || 0);
            const hasShortage = s.closed_at && Math.abs(shortage) > 100;
            return (
              <div key={s.id} style={{ padding: '14px 20px', borderBottom: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{s.operator_name}</div>
                    <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>
                      {fmtDate(s.opened_at)} · {fmtTime(s.opened_at)}
                      {s.closed_at ? ` — ${fmtTime(s.closed_at)}` : ` (${t('openTag')})`}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--green)' }}>{fmt(s.total_revenue)}</div>
                    <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 2 }}>
                      {s.session_count} sessiya · {fmtDur(s.duration_hours || 0)}
                    </div>
                  </div>
                </div>
                {/* Breakdown mini */}
                {s.closed_at && (
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
                    {Number(s.snack_revenue) > 0 && (
                      <span style={{ fontSize: 10, background: 'rgba(255,193,7,0.1)', color: 'var(--yellow)',
                        border: '1px solid rgba(255,193,7,0.3)', padding: '2px 8px', borderRadius: 10 }}>
                        🍕 {fmtN(s.snack_revenue)}
                      </span>
                    )}
                    {hasShortage && (
                      <span style={{ fontSize: 10,
                        background: shortage > 0 ? 'rgba(255,59,92,0.1)' : 'rgba(0,255,136,0.1)',
                        color: shortage > 0 ? 'var(--red)' : 'var(--green)',
                        border: `1px solid ${shortage > 0 ? 'rgba(255,59,92,0.3)' : 'rgba(0,255,136,0.3)'}`,
                        padding: '2px 8px', borderRadius: 10 }}>
                        {shortage > 0 ? '⚠️ ' : '✅ '}{shortage > 0 ? t('shortage') : t('surplus')}: {Math.abs(shortage).toLocaleString()}
                      </span>
                    )}
                    <button onClick={async () => {
                      try {
                        const res = await api.get(`/kassa/shifts/${s.id}/zreport`);
                        setReportData(res.data); setReportType('z');
                      } catch {}
                    }} style={{ fontSize: 10, background: 'transparent', border: '1px solid var(--border)',
                      color: 'var(--text3)', padding: '2px 8px', borderRadius: 10, cursor: 'pointer' }}>
                      {t('zReport')}
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* AUDIT LOG */}
        <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--border)',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 11, color: 'var(--text2)', letterSpacing: 2, textTransform: 'uppercase' }}>{t('auditLog')}</div>
            <button onClick={load} style={{ background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text2)', padding: '5px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 11 }}>
              ↻ {t('refresh')}
            </button>
          </div>

          {audit.length === 0 ? (
            <div style={{ padding: '32px 20px', textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
              {t('noRecords')}
            </div>
          ) : (
            <div style={{ maxHeight: 520, overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: 'var(--card)' }}>
                    {[t('colTime'), t('colAction'), t('colWho'), t('colAmount'), t('colDetails')].map(h => (
                      <th key={h} style={{ padding: '10px 16px', textAlign: 'left', color: 'var(--text2)',
                        fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {audit.map(row => {
                    const meta = actionMeta[row.action] || { label: row.action, color: 'var(--text2)', icon: '·' };
                    const detail = row.meta && Object.keys(row.meta).length
                      ? Object.values(row.meta).join(' · ') : '—';
                    return (
                      <tr key={row.id} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '10px 16px', color: 'var(--text3)', whiteSpace: 'nowrap' }}>{fmtTime(row.created_at)}</td>
                        <td style={{ padding: '10px 16px', whiteSpace: 'nowrap' }}>
                          <span style={{ background: meta.color + '18', border: `1px solid ${meta.color}40`,
                            color: meta.color, padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>
                            {meta.icon} {meta.label}
                          </span>
                        </td>
                        <td style={{ padding: '10px 16px', color: 'var(--text)' }}>{row.actor_name || row.actor_type || '—'}</td>
                        <td style={{ padding: '10px 16px', color: row.amount ? 'var(--green)' : 'var(--text3)',
                          fontWeight: row.amount ? 700 : 400, whiteSpace: 'nowrap' }}>
                          {row.amount ? '+' + Number(row.amount).toLocaleString() : '—'}
                        </td>
                        <td style={{ padding: '10px 16px', color: 'var(--text2)', maxWidth: 200,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {detail}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
